// src/features/auth/hooks/useAuth.ts
import { useEffect } from 'react';
import useAuthStore from '../../../store/authStore';
import authService from '../../../services/authService';
import { fetchUserProfile } from '../../account/api/accountApi';

export const useAuth = () => {
  const { user, isLoading, error, setUser } = useAuthStore();

  // Check authentication status on mount
  useEffect(() => {
    const checkAuthStatus = async () => {
      if (authService.isAuthenticated() && !user) {
        try {
          // Try to fetch user profile
          await fetchUserProfile();
        } catch (error) {
          // If error, clear tokens as they might be expired
          authService.logout();
        }
      }
    };

    checkAuthStatus();
  }, [user]);

  return {
    isAuthenticated: !!user,
    user,
    isLoading,
    error,
  };
};

export default useAuth;